import { render, staticRenderFns } from "./AccessGroupRule.vue?vue&type=template&id=7508cbdd&"
import script from "./AccessGroupRule.vue?vue&type=script&lang=js&"
export * from "./AccessGroupRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports